import { computed } from "@/composition-api";
import store from "@/store";

export const isCuratedSearchAndPlaylistsEnabled = computed(() => {
  return store.state.stageconfig.config.features
    .enableCuratedSearchesAndPlaylists;
});
